export * from "/builds/91/alb-albatros-travel/alb-frontend/node_modules/@fortawesome/fontawesome-svg-core/index.mjs"